module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0746d_logo_200x200.2a67cef2.png";